/**
 * Bulk actions for the admin Users table: shadcn Button + DropdownMenu
 * (replaces the MUI Menu/MenuItem/ListItemIcon version).
 */
import { buttonVariants } from "@/components/ui/button";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";
import { ChevronDown, Trash2 } from "lucide-react";
import { useState } from "react";

import { DeleteUsersDialog } from "./dialogs/DeleteUsersDialog";

interface UserTableToolbarActionsProps {
    selectedUserIds: number[];
    /** Called after a bulk delete succeeds (the page clears its selection). */
    onDeleted?: () => void;
}

export function UserTableToolbarActions({
    selectedUserIds,
    onDeleted,
}: UserTableToolbarActionsProps) {
    const [deleteOpen, setDeleteOpen] = useState(false);

    return (
        <>
            <DropdownMenu>
                <DropdownMenuTrigger
                    className={cn(buttonVariants({ variant: "outline" }))}
                >
                    Actions
                    <ChevronDown className="size-4" />
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="min-w-56">
                    <DropdownMenuItem
                        variant="destructive"
                        disabled={selectedUserIds.length === 0}
                        onClick={() => setDeleteOpen(true)}
                    >
                        <Trash2 className="size-4" />
                        Delete Selected
                    </DropdownMenuItem>
                </DropdownMenuContent>
            </DropdownMenu>
            <DeleteUsersDialog
                open={deleteOpen}
                onOpenChange={setDeleteOpen}
                userIds={selectedUserIds}
                onDeleted={onDeleted}
            />
        </>
    );
}
